import React from 'react';
import PropTypes from 'prop-types';
import useStatefulId from '@/lib/hooks/useStatefulId';
import translate from '@/lib/intl/translate';
import ControlledMinMaxNumberInputs from './ControlledMinMaxNumberInputs';

function parse(value) {
  if (typeof value === 'string' && value.length === 0) return null;

  return parseInt(value, 10);
}

export default function ControlledMinMaxDonation({
  classes = ControlledMinMaxNumberInputs.defaultProps.classes,
  disabled = false,
  id = '',
  name = 'donation',
  label = translate('CONSTITUENT_TOTAL_AMT_CONTRIBUTED'),
  maxRequired = false,
  minRequired = false,
  maxName = '',
  minName = '',
}) {
  const statefulId = useStatefulId(id);

  return (
    <ControlledMinMaxNumberInputs
      classes={classes}
      disabled={disabled}
      id={statefulId}
      label={label}
      maxRequired={maxRequired}
      minRequired={minRequired}
      maxName={maxName}
      minName={minName}
      name={name}
      parse={parse}
      prefix="$"
      thousandSeparator
      validationError={translate('FORMS_VALIDATION_MIN_AMOUNT_INVALID')}
    />
  );
}

ControlledMinMaxDonation.propTypes = {
  classes: ControlledMinMaxNumberInputs.propTypes.classes,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  maxRequired: PropTypes.bool,
  minRequired: PropTypes.bool,
  maxName: PropTypes.string,
  minName: PropTypes.string,
  name: PropTypes.string,
};
